<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    cinematic_blur
                </mat-icon>
                <span>
                    Engagement: {{ this.itemEnvelope?.ItemId }}: {{ this.itemEnvelope?.ItemName }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                {{ subtitle }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <div class="flex-direction-horizontal">
                    <div class="flex-container-basic">
                        <div class="circle-container-medium">
                            <div class="half left">
                                <app-image srcPath="{{ avatarUrlResource }}" isApiImage="true" className="app-image-medium app-image-circle"></app-image>
                            </div>
                            <div class="half right">
                                <app-image srcPath="{{ avatarUrlProduction }}" isApiImage="true" className="app-image-medium circle-container-medium-right-img"></app-image>
                            </div>
                        </div>
                        <button *ngIf="itemEnvelope?.ItemId" mat-button class="button-mini button-inconspicuous avatar-button button-narrow" (click)="editAvatar()">
                            <mat-icon class="material-symbols-outlined">
                                edit
                            </mat-icon>
                        </button>
                    </div>
                    <div class="flex-direction-vertical flex-container-basic">
                        <app-chip-selector #resourceChipSelector idLinkPath="resource" label="Resource" className="width-medium-narrow" [isMultiSelect]="false" [availableItems]="availableResources" [selectedItemIds]="selectedResourceIds"></app-chip-selector>
                        <br />
                        <app-chip-selector #productionChipSelector idLinkPath="production" label="Production" className="width-medium-narrow" [isMultiSelect]="false" [availableItems]="availableProductions" [selectedItemIds]="selectedProductionIds"></app-chip-selector>
                    </div>
                </div>
            </form>
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <br />
                <mat-tab label="General">
                    <br />
                    <mat-form-field appearance="outline">
                        <mat-label>Role</mat-label>
                        <mat-select name="ProductionRoles" [(ngModel)]="this.itemEnvelope?.Document?.Item.ProductionRoleId">
                            <mat-option *ngFor="let productionRole of this.availableProductionRoles" [value]="productionRole.ProductionRoleId">{{ productionRole.Name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <br />
                    <mat-form-field appearance="outline">
                        <mat-label>Status</mat-label>
                        <mat-select name="EngagementStatuses" [(ngModel)]="this.itemEnvelope?.Document?.Item.EngagementStatusId">
                            <mat-option *ngFor="let engagementStatus of this.engagementStatuses" [value]="engagementStatus.EngagementStatusId">{{ engagementStatus.UID }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <br />
                    <mat-form-field appearance="outline">
                        <mat-label>Start On</mat-label>
                        <input matInput [matDatepicker]="picker" [(ngModel)]="this.itemEnvelope?.Document?.Item.StartOnUTC" />
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
